import AuthGuard from 'app/auth/AuthGuard';
import chartsRoute from 'app/views/charts/ChartsRoute';
import dashboardRoutes from 'app/views/dashboard/DashboardRoutes';
import materialRoutes from 'app/views/material-kit/MaterialRoutes';
import NotFound from 'app/views/sessions/NotFound';
import sessionRoutes from 'app/views/sessions/SessionRoutes';
import { Navigate } from 'react-router-dom';
import FollowGreenLayout from './components/FollowGreenLayout/FollowGreenLayout';
import adminRoutes from 'app/views/admin/AdminRoutes';

const routes = [
  {
    element: (
      <AuthGuard>
        <FollowGreenLayout />
      </AuthGuard>
    ),
    children: [...dashboardRoutes, ...adminRoutes, ...chartsRoute, ...materialRoutes],
  },
  ...sessionRoutes,
  { path: '/', element: <Navigate to="dashboard/main" /> },
  { path: '*', element: <NotFound /> },
];

export default routes;
